import { v4 as uuid } from 'uuid';
import styles from './TextHighlight.module.scss';
import { queryString, queryEscapedString } from './utils';
import { FC } from 'react';
import cx from 'classnames';

interface TextHighlightProps {
  text?: string;
  textToHighlight?: string;
  highlightClassName?: string;
  isEscape?: boolean;
  isVirtualScroll?: boolean;
  isSpecialCharacters?: boolean;
}

export const TextHighlight: FC<TextHighlightProps> = ({
  text = '',
  textToHighlight = '',
  highlightClassName,
  isEscape,
  isVirtualScroll = false,
  isSpecialCharacters = false
}) => {
  let regex: RegExp;
  if (isEscape) {
    regex = new RegExp(`(${queryString(textToHighlight)})`, 'gi');
  } else {
    regex = isSpecialCharacters
      ? new RegExp(`(${queryEscapedString(textToHighlight)})`, 'gi')
      : new RegExp(`(${textToHighlight})`, 'gi');
  }

  const parts = text.split(regex);

  if (!textToHighlight.trim()) {
    return (
      <span
        className={cx(highlightClassName, styles['highlight-text'])}
        key={uuid()}
      >
        {text}
      </span>
    );
  }

  return (
    <span
      className={cx(styles['highlight-text'], {
        [`${highlightClassName}`]: isVirtualScroll
      })}
    >
      {parts
        .filter((part) => part)
        .map((part) =>
          regex.test(part) ? (
            <span key={uuid()} className={cx(styles['highlight'])}>
              {part}
            </span>
          ) : (
            <span key={uuid()}>{part}</span>
          )
        )}
    </span>
  );
};
